import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-1" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "text-gray-500 italic"
}
const _hoisted_4 = {
  key: 0,
  class: "absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
}
const _hoisted_5 = {
  class: "max-h-60 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm",
  role: "listbox"
}
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["checked", "indeterminate", "disabled"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = ["checked", "disabled", "onClick"]
const _hoisted_11 = { class: "ml-3 block truncate" }

import { ref, computed, onMounted, onUnmounted } from 'vue'


export default {
  __name: 'MultiSelectInput',
  props: {
  modelValue: {
    type: Array,
    required: true
  },
  options: {
    type: Array,
    required: true
  },
  placeholder: {
    type: String,
    default: 'Select options'
  },
  showSelectAll: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const isOpen = ref(false)
const dropdownRef = ref(null)

const selectedOptions = computed(() => props.options.filter(option => props.modelValue.includes(option.value)))

const hasSelectableOptions = computed(() => props.options.some(option => !option.disabled))

const allSelected = computed(() => {
  const nonDisabledOptions = props.options.filter(option => !option.disabled)
  return nonDisabledOptions.length > 0 && nonDisabledOptions.every(option => props.modelValue.includes(option.value))
})

const someSelected = computed(
  () => !allSelected.value && props.options.some(option => !option.disabled && props.modelValue.includes(option.value))
)

const isSelected = value => props.modelValue.includes(value)

const toggleOption = value => {
  const newValue = [...props.modelValue]
  const index = newValue.indexOf(value)

  if (index === -1) {
    newValue.push(value)
  } else {
    newValue.splice(index, 1)
  }

  emit('update:modelValue', newValue)
}

const toggleAll = () => {
  if (allSelected.value) {
    emit('update:modelValue', [])
  } else {
    emit(
      'update:modelValue',
      props.options.filter(option => !option.disabled).map(option => option.value)
    )
  }
}

const removeOption = value => {
  const newValue = props.modelValue.filter(v => v !== value)
  emit('update:modelValue', newValue)
}

const handleClickOutside = event => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative w-full",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("div", {
      class: "block w-full rounded-md border border-gray-300 pl-3 pr-10 py-2 text-base focus-within:border-brand-500 focus-within:outline-none focus-within:ring-1 focus-within:ring-brand-500 sm:text-sm cursor-pointer",
      onClick: _cache[0] || (_cache[0] = $event => (isOpen.value = !isOpen.value))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (__props.modelValue.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedOptions.value, (selected) => {
              return (_openBlock(), _createElementBlock("span", {
                key: selected.value,
                class: "inline-flex items-center px-2 py-0.5 rounded bg-gray-100 text-sm"
              }, [
                _createTextVNode(_toDisplayString(selected.name) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "ml-1 inline-flex text-gray-400 hover:text-gray-500",
                  onClick: _withModifiers($event => (removeOption(selected.value)), ["stop"])
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "sr-only" }, "Remove", -1),
                  _createTextVNode(" × ", -1)
                ]))], 8, _hoisted_2)
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.placeholder), 1))
      ])
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (__props.showSelectAll)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass(["relative select-none py-2 pl-3 pr-9 border-b border-gray-200", {
              'bg-gray-100': allSelected.value,
              'cursor-pointer hover:bg-gray-100': hasSelectableOptions.value,
              'cursor-not-allowed opacity-50': !hasSelectableOptions.value
            }]),
                  onClick: _cache[2] || (_cache[2] = _withModifiers($event => (hasSelectableOptions.value && toggleAll()), ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: allSelected.value,
                      indeterminate: someSelected.value,
                      disabled: !hasSelectableOptions.value,
                      class: "h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500 disabled:opacity-50 disabled:cursor-not-allowed",
                      onClick: _cache[1] || (_cache[1] = _withModifiers($event => (hasSelectableOptions.value && toggleAll()), ["stop"]))
                    }, null, 8, _hoisted_7),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ml-3 block truncate font-medium" }, "Select all", -1))
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
              return (_openBlock(), _createElementBlock("li", {
                key: option.value,
                class: _normalizeClass(["relative select-none py-2 pl-3 pr-9", {
            'bg-gray-100': isSelected(option.value),
            'cursor-pointer hover:bg-gray-100': !option.disabled,
            'cursor-not-allowed opacity-50': option.disabled
          }]),
                onClick: $event => (!option.disabled && toggleOption(option.value))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: isSelected(option.value),
                    disabled: option.disabled,
                    class: "h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500 disabled:opacity-50 disabled:cursor-not-allowed",
                    onClick: _withModifiers($event => (!option.disabled && toggleOption(option.value)), ["stop"])
                  }, null, 8, _hoisted_10),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(option.name), 1)
                ])
              ], 10, _hoisted_8))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

}